


































import Vue from "vue";
import i18n from "@/locales/i18n";
import { datetimeFormat } from "@/utils/lang";

export default Vue.extend({
    name: "DateTimePicker",
    props: {
        rightIcon: {
            type: String,
            default: ""
        },
        value: {
            type: String
        },
        label: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: i18n.t("common.placeholder.select")
        },
        rules: Array,
        dateTimeTitle: String,
        dateTimeType: {
            type: String,
            default: "date"
        },
        minDate: {
            type: Date,
            default: () => new Date(1900, 1, 1)
        },
        maxDate: {
            type: Date,
            default: () => new Date()
        },
        minHour: {
            type: Number,
            default: 0
        },
        maxHour: {
            type: Number,
            default: 23
        },
        minMinute: {
            type: Number,
            default: 0
        },
        maxMinute: {
            type: Number,
            default: 59
        },
        formatter: {
            type: Function,
            default: function(type, val) {
                switch (type) {
                    case "year":
                        return val + i18n.t("common.date.year");
                    case "month":
                        return val + i18n.t("common.date.month");
                    case "day":
                        return val + i18n.t("common.date.day");
                    case "hour":
                        return val + i18n.t("common.date.hour");
                    case "minute":
                        return val + i18n.t("common.date.minute");
                    default:
                        return val;
                }
            }
        }
    },
    data() {
        return {
            selectedText: this.value,
            showPicker: false,
            selectedDate: this.value ? new Date(this.value) : new Date()
        };
    },
    methods: {
        onConfirm() {
            this.showPicker = false;
            this.selectedText = datetimeFormat(this.selectedDate, this.$constants.DATE_FMT);
            this.$emit("input", this.selectedText);
            this.$emit("blur", this.selectedText);
            this.$emit("change", this.selectedText);
        }
    },
    watch: {
        value(newVal) {
            if (newVal) {
                this.selectedText = newVal;
                this.selectedDate = newVal ? new Date(newVal) : new Date();
            }
        }
    }
});
